import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";


import axios from "axios";
import eightAxios from "../../configs/axiosConfig";
// material UI components
import Grid from "@material-ui/core/Grid";

// Custom Components
import Filter from "@Components/Filter";
import Table from "@Components/Table";
import Modal from "@Components/Modal";

import { fetchDataFromApi } from "utils";
import {
  BLOCK_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  LIST_SUPERVISOR_URL,
  LIST_WORKER_GROUP_URL,
  PRE_ASSIGN_CHECK_URL,
  REGION_FETCH_URL,
  SUPERVISOR_ASSIGN_URL,
  SUPERVISOR_REMOVE_URL,
  WORKER_GROUP_ASSIGN_URL,
  WORKER_GROUP_PRE_ASSIGN_CHECK_URL,
  WORKER_REMOVE_URL,
  ZONE_FETCH_URL,
} from "configs/constants";
import ConfirmDialog from "@Components/ConfirmDialog";
import Notify from "@Components/Notify";
import { SUPERVISOR_DISCLAIMER_MESSAGE } from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";

const urls = {
  proxyURL: "supervisor-assignment/",
};

const model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "supervisor_code_name", label: "Supervisor", type: "string" },
  { id: "worker_group_code_name", label: "Worker Group", type: "string" },
  { id: "zone_code_name", label: "Zone", type: "string" },
  { id: "region_code_name", label: "Region", type: "string" },
  { id: "estate_code_name", label: "Estate", type: "string" },
  { id: "division_code_name", label: "Division", type: "string" },
  { id: "block_code_name", label: "Block", type: "string" },
];

const SelectSupervisor = (props) => { 
  const { supervisor, setSupervisors, preCheckMsg } = props;
  const handleChange = (event) => {
    setSupervisors(event.target.value);
  };
  return (
    <Grid container direction="column" spacing={5}>
      <Grid item>
        <form>
          <select
            name="supervisor"
            className="form-control"
            onChange={handleChange}
          >
            <option>Select Supervisors</option>
            {supervisor.map(({ id, employee_id_name }) => (
              <option value={id} key={id}>
                {employee_id_name}
              </option>
            ))}
          </select>
        </form>
        <p>{preCheckMsg}</p>
      </Grid>
    </Grid>
  );
};
SelectSupervisor.propTypes = {
  supervisor: PropTypes.object,
  setSupervisors: PropTypes.func,
  preCheckMsg: PropTypes.string,
};

const SelectWorkerGroup = (props) => {
  const { workerGroups, setWorkerGroup, preCheckMsg } = props;
  const handleChange = (event) => {
    setWorkerGroup(event.target.value);
  };
  return (
    <Grid container direction="column" spacing={5}>
      <Grid item>
        <form>
          <select
            name="worker_group"
            className="form-control"
            onChange={handleChange}
          >
            <option>Select Worker Group</option>
            {workerGroups.map(({ id, group_id, name }) => (
              <option value={id} key={id} data-id={group_id}>
                {name}
              </option>
            ))}
          </select>
        </form>
        <p>{preCheckMsg}</p>
      </Grid>
    </Grid>
  );
};
SelectWorkerGroup.propTypes = {
  workerGroups: PropTypes.object,
  setWorkerGroup: PropTypes.func,
  preCheckMsg: PropTypes.string,
};

export default function SupervisorAssignmentList() {
  const [selected, setSelected] = useState([]);
  const [selectedEmployeeId,setSelectedEmployeeId] = useState([]);
  const [supervisor, setSupervisor] = useState(null);
  const [preCheckMsg, setPreCheckMsg] = useState("");
  const [supervisors, setSupervisors] = useState("");
  const [filterValues, setFilterValues] = useState({});
  const [workerGroups, setWorkerGroups] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [workerGroup, setWorkerGroup] = useState("");
  const [yoloState, setYoloState] = useState(false);
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [disableZone, setDisableZone] = useState(true);


  const [modalFields, setModalFields] = useState({
    title: "Supervisor Assignment",
    isOpen: false,
    body: null,
    confirmButtonLabel: "Save",
    resetModalBodyState: () => {
      setYoloState(false);
    },
    bodyMessage: null,
  });
  // const validationSchema = Yup.object({
  
  //   region: Yup.string()
  //   .required("Region is required")
  //   .typeError("Invalid Region")
  //   .nullable(),
  //   estate: Yup.string()
  //   .required("Estate is required")
  //   .typeError("Invalid Estate")
  //   .nullable(),
  //   zone: Yup.string()
  //   .required("Zone is required")
  //   .typeError("Invalid Zone")
  //   .nullable(),
  
   
  // });
  const [isWorkerGroup, setIsWorkerGroup] = useState(false);
  const API_VERSION = "v1";
  const API_URL = process.env.REACT_APP_API_URL;
  let baseURL = `${API_URL}${API_VERSION}/`;
  const pageNumberDropdown = true;
  const showInfoIcon = true;
  const infoContent = SUPERVISOR_DISCLAIMER_MESSAGE;


  const filterFields = [
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,

      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,
      paginated: true,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: "input",
      label: "Worker ID",
      name: "worker_id",
    },
    {
      type: "input",
      label: "Worker Name",
      name: "worker_name",
    },
    {
      type: "reactselect",
      label: "Supervisor",
      name: "supervisor",
      outerOptions: supervisor,
    },
  ];

  useEffect(() => {
    setRefresh(false);
  }, [refresh]);
  useEffect(() => {
    fetchDataFromApi(LIST_SUPERVISOR_URL, setSupervisor, false);
  }, []);
  useEffect(() => {
    fetchDataFromApi(LIST_WORKER_GROUP_URL, setWorkerGroups, false);
  }, []);

  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };

  const getZoneValues = (e,setDisableRegion) => {
  //  if (!e || e.length === 0) {
    if (!e || e.length === 0 || e.label == "N/A") {
      setDisableRegion(true);
      setEmptyFlag(true)
    }
    else {
      setDisableRegion(false);
      setEmptyFlag(false)
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };
  
  const getEstateValues = (e,setDisableDivision) => {
    if (!e || e.length === 0) {
      setDisableDivision(true);
    }
    else {
      setDisableDivision(false);
    }
    
  };
  const getDivisonValues = (e,setDisableBlock) => {
    if (!e || e.length === 0) {
      setDisableBlock(true);
    }
    else {
      setDisableBlock(false);
    }
    
  };
  useEffect(() => {
    if (isWorkerGroup) {
      setModalFields({
        ...modalFields,
        body: (
          <SelectWorkerGroup
            workerGroups={workerGroups}
            setWorkerGroup={setWorkerGroup}
            preCheckMsg={preCheckMsg}
          />
        ),
      });
    } else {
      if (!supervisor) {
        fetchDataFromApi(LIST_SUPERVISOR_URL, setSupervisor, false);
      }
      setModalFields({
        ...modalFields,
        body: (
          <SelectSupervisor
            supervisor={supervisor}
            setSupervisors={setSupervisors}
            preCheckMsg={preCheckMsg}
          />
        ),
      });
    }
  }, [supervisor, supervisors, workerGroups, preCheckMsg]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const userRoles = localStorage.getItem("roles");
  const [emptyFlag, setEmptyFlag] = useState(false)

  const actionBarButtons = [
    // {
    //   color: "primary",
    //   buttonLabel: "Assign Supervisor",
    //   onClick: () => {
    //     console.log(userRoles);
    //     const body = { ids: selected, filter_params: filterValues };
    //     if (selected.length === 0) {
    //       setNotify({
    //         isOpen: true,
    //         message: "Please select one or more user/s",
    //         type: "error",
    //       });
    //     } else {
    //       const url = baseURL + PRE_ASSIGN_CHECK_URL;
    //       const headers = {
    //         Authorization: `JWT ${localStorage.getItem("token")}`,
    //       };
    //       axios({
    //         url: url,
    //         method: "get",
    //         headers: headers,
    //         params: body,
    //       })
    //         .then(function (response) {
    //           // your action after success
    //           setPreCheckMsg(response.data.message);
    //           setIsWorkerGroup(false);
    //           setYoloState(true);

    //         })
    //         .catch(function (error) {
    //           if (error.response) {
    //             setPreCheckMsg(error.response.data.message);
    //             setIsWorkerGroup(false);
    //             setYoloState(true);
    //           } else {
    //             console.log(error);
    //           }
    //         });
    //     }
    //   },
    // },
    // {
    //   color: "primary",
    //   buttonLabel: "Remove Supervisor Assignment",
    //   onClick: () =>
    //     setConfirmDialog({
    //       ...confirmDialog,
    //       isOpen: true,
    //       title:
    //         "ARE YOU SURE TO REMOVE SUPERVISOR ASSIGNMENT FOR THESE WORKERS?",
    //       subTitle: "YOU CANNOT UNDO THIS OPERATION",
    //       onConfirm: () => {
    //         const body = { ids: selected, filter_params: filterValues };
    //         eightAxios
    //           .patch(SUPERVISOR_REMOVE_URL, body)
    //           .then(() => {
    //             setNotify({
    //               isOpen: true,
    //               message: "Record Deleted Successfully",
    //               type: "success",
    //             });

    //             setRefresh(true);
    //             setConfirmDialog({ ...confirmDialog, isOpen: false });
    //             // location.reload();

    //           })
    //           .catch(() => {
    //             setNotify({
    //               isOpen: true,
    //               message: "Failed to delete the record",
    //               type: "error",
    //             });
    //             setRefresh(true);
    //             setConfirmDialog({ ...confirmDialog, isOpen: false });
    //           });
    //       },
    //     }),
    // },
    {
      color: "primary",
      buttonLabel: "Assign Worker Group",
      onClick: () => {
        const body = { ids: selected,employee_ids:selectedEmployeeId, filter_params: filterValues };
        const url = baseURL + WORKER_GROUP_PRE_ASSIGN_CHECK_URL;
        const headers = {
          Authorization: `JWT ${localStorage.getItem("token")}`,
        };
        axios({
          url: url,
          method: "get",
          headers: headers,
          params: body,
        })
          .then(function (response) {
            // your action after success
            setPreCheckMsg(response.data.message);
            setIsWorkerGroup(true);
            setYoloState(true);
          })
          .catch(function (error) {
            if (error.response) {
              setPreCheckMsg(error.response.data.message);
              setIsWorkerGroup(true);
              setYoloState(true);
            } else {
              console.log(error);
            }
          });
      },
    },
    {
      color: "primary",
      buttonLabel: "Remove Worker Group Assignment",
      onClick: () =>
        setConfirmDialog({
          ...confirmDialog,
          isOpen: true,
          title:
            "Are you sure to remove worker group assignment for these workers?",
          subTitle: "You cannot undo this operation",
          onConfirm: () => {
            const body = { ids: selected,employee_ids: selectedEmployeeId, filter_params: filterValues };
            eightAxios
              .patch(WORKER_REMOVE_URL, body)
              .then(() => {
                setNotify({
                  isOpen: true,
                  message: "Record Deleted Successfully",
                  type: "success",
                });
                setRefresh(true);
                setConfirmDialog({ ...confirmDialog, isOpen: false });
              })
              .catch(() => {
                setNotify({
                  isOpen: true,
                  message: "Failed to delete the record",
                  type: "error",
                });
                setRefresh(true);
                setConfirmDialog({ ...confirmDialog, isOpen: false });
              });
          },
        }),
    },
  ];
  const disabledActionBarButtons = [
    // {
    //   color: "primary",
    //   buttonLabel: "Assign Supervisor",
    //   disabled: true,
    // },
    // {
    //   color: "primary",
    //   buttonLabel: "Remove Supervisor Assignment",
    //   disabled: true,
    // },
    {
      color: "primary",
      buttonLabel: "Assign Worker Group",
      disabled: true,
      
    },
    {
      color: "primary",
      buttonLabel: "Remove Worker Group Assignment",
      disabled: true,
    },
  ];

  const filterInitialValues = {
    status: "",
    company: "",
    zone: "",
    region: "",
    estate: "",
    block: "",
    worker_id: "",
    worker_name: "",
    supervisor: "",
  };

  const onFilterRequest = (values) => {
    setFiltersApplied(true); 

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  useEffect(() => {
    let body = null;
    let confirm;
    if (isWorkerGroup) {
      body = (
        <SelectWorkerGroup
          workerGroups={workerGroups}
          setWorkerGroup={setWorkerGroup}
          preCheckMsg={preCheckMsg}
        />
      );
      confirm = () => {
        const body = {
          ids: selected,
          employee_ids: selectedEmployeeId,
          worker_group: workerGroup,
          filter_params: filterValues,
        };
        eightAxios
          .patch(WORKER_GROUP_ASSIGN_URL, body)
          .then((response) => {
            setRefresh(true);
            setNotify({
              isOpen: true,
              message: "Worker Group Assigned Successfully",
              type: "success",
            });
            console.log(response.data);
          })
          .catch((error) => {
            setRefresh(true);
            setNotify({
              isOpen: true,
              message: "Failed to assign worker group",
              type: "error",
            });
            console.error(error);
          });
        setModalFields({
          ...modalFields,
          isOpen: false,
        });
        setYoloState(false);
      };
    } else {
      body = (
        <SelectSupervisor
          supervisor={supervisor}
          setSupervisors={setSupervisors}
          preCheckMsg={preCheckMsg}
        />
      );
      confirm = () => {
        const body = {
          ids: selected,
          
          supervisor: supervisors,
          filter_params: filterValues,
        };
        eightAxios
          .patch(SUPERVISOR_ASSIGN_URL, body)
          .then(() => {
            setNotify({
              isOpen: true,
              message: "Supervisor Assigned Successfully",
              type: "success",
            });
            
            setSelected([]);
            setRefresh(true);
            //  location.reload();

          })
          .catch((error) => {
            setNotify({
              isOpen: true,
              message: "Failed to assign supervisor",
              type: "error",
            });
            setRefresh(true);
            console.error(error);
          });
        setYoloState(false);
        setModalFields({
          ...modalFields,
          isOpen: false,
        });
      };
    }
    if (yoloState) {
      setModalFields({
        ...modalFields,
        isOpen: true,
        body: body,
        onConfirm: confirm,
      });
    } else {
      setModalFields({
        ...modalFields,
        isOpen: false,
        body: body,
        onConfirm: confirm,
      });
    }
  }, [yoloState, isWorkerGroup, supervisors, workerGroup]);
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }

  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}
        // validationSchema={validationSchema}


      />
{filtersApplied ? ( 

      <Table
      //  proxyURL={!emptyFlag && urls.proxyURL}
      proxyURL={urls.proxyURL}
        model={model}
        refresh={refresh}
        actionBarButtons={
          localStorage.getItem("roles").includes("Supervisor")
            ? actionBarButtons
            : disabledActionBarButtons
        }
        noFilter
        filterValues={filterValues}
        noAddButton
        excelExport={{ fileName: "SupervisorAssignmentReport" }}
        check
        // prop to get selected values
        selected={selected}
        selectedEmployeeId={selectedEmployeeId}
        // callback setter
        setSelected={setSelected}
        setSelectedEmployeeId={setSelectedEmployeeId}
        pageNumberDropdown={pageNumberDropdown}
        showInfoIcon={showInfoIcon}
        infoContent={infoContent}


      />
      ) : (
        <Table
        proxyURL={null}
        model={model}
        refresh={refresh}
        actionBarButtons={
          localStorage.getItem("roles").includes("Supervisor")
            ? actionBarButtons
            : disabledActionBarButtons
        }
        noFilter
        filterValues={filterValues}
        noAddButton
        excelExport={{ fileName: "SupervisorAssignmentReport" }}
        check
        // prop to get selected values
        selected={selected}
        selectedEmployeeId={selectedEmployeeId}
        // callback setter
        setSelected={setSelected}
        setSelectedEmployeeId={setSelectedEmployeeId}
        pageNumberDropdown={pageNumberDropdown}
        showInfoIcon={showInfoIcon}
        infoContent={infoContent}


      />
      )}

      <Modal modalFields={modalFields} setModalFields={setModalFields} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <Notify notify={notify} setNotify={setNotify} />
    </div>
  );
}
